module.exports = __webpack_public_path__ + "img/google-chrome.e655592d.svg";